"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _LogMonitor = _interopRequireDefault(require("./LogMonitor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _LogMonitor["default"];
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6WyJMb2dNb25pdG9yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7ZUFDZUEsc0IiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgTG9nTW9uaXRvciBmcm9tICcuL0xvZ01vbml0b3InO1xuZXhwb3J0IGRlZmF1bHQgTG9nTW9uaXRvcjtcbiJdfQ==